import './App.css';
import Particales from './Particales/Particales';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import MyProjects from './Componentes/MyProjects';
import { Route, Routes } from 'react-router-dom';
import ProjectDetails from './Componentes/ProjectDetails';
import Home from './Componentes/Home';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
AOS.init();

function App() {
  return (
    <div >
      <Particales/>
     
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='project' element={<MyProjects></MyProjects>}></Route>
        <Route path='project/:id' element={<ProjectDetails></ProjectDetails>}></Route>
      </Routes>
      
      <ToastContainer />
    </div>
  );
}

export default App;
